import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, BrowserRouter } from "react-router-dom";
import { Toaster } from 'react-hot-toast' 


import App from './App';

import {store, persistor} from './Redux/app/store'
import { Provider } from 'react-redux'
import { NotificationsProvider } from './Hooks/useNotifications'
import { LightboxProvider } from './Hooks/useLightbox';

import { PersistGate } from 'redux-persist/integration/react'



const root = ReactDOM.createRoot(document.getElementById('root'));
{/* <React.StrictMode> */}
root.render(
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					<NotificationsProvider>
						<LightboxProvider>
							<App />
							<Toaster position="top-center" reverseOrder={false}/>
						</LightboxProvider>
					</NotificationsProvider>
				</BrowserRouter>
			</PersistGate>
		</Provider>
);
	{/* </React.StrictMode> */}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

